import { render, staticRenderFns } from "./FAQItem.vue?vue&type=template&id=d38fcbd4&scoped=true&"
import script from "./FAQItem.vue?vue&type=script&lang=ts&"
export * from "./FAQItem.vue?vue&type=script&lang=ts&"
import style0 from "./FAQItem.vue?vue&type=style&index=0&id=d38fcbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38fcbd4",
  null
  
)

export default component.exports